<div id="login-page">
  <div id="login-box" class="login animated u-slow-appear">
    <img src="assets/images/logo-big@2x.png" alt="App logo" />

    <form
      validate
      #loginForm="ngForm"
      (ngSubmit)="login(sessionService.authType === 'auth365', loginForm.form.value)"
      [ngClass]="{ submitted: loginForm.submitted }">
      @if (sessionService.authType === 'classicAnd365') {
      <div>
        <div id="login-auth365" class="small text-center mb-2">{{ 'LOGIN_WITH_YOUR_MICROSOFT_ACCOUNT' | agrTranslate }}</div>
        <div class="d-grid form-group">
          <button class="btn btn-primary" id="auth365Login" (click)="login(true, undefined)">Login via Microsoft</button>
        </div>
      </div>
      } @if (['classic', 'classicAnd365'].includes(sessionService.authType)) {
      <div id="login-user" class="form-group">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa fa-user"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="{{ 'EMAIL_OR_USERNAME' | agrTranslate }}"
            required
            [(ngModel)]="user"
            name="user"
            autofocus
            #userField />
        </div>
      </div>
      } @if (['classic', 'classicAnd365'].includes(sessionService.authType)) {
      <div id="login-password" class="form-group">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa fa-lock"></i>
          </span>
          <input
            type="text"
            class="form-control"
            name="password"
            type="password"
            placeholder="{{ 'PASSWORD' | agrTranslate }}"
            required
            [(ngModel)]="password"
            #passwordField />
        </div>
        @if (loginError) {
        <div class="mt-2">
          <span id="login-invalid-msg" class="text-danger"> {{ 'LOGIN_UNSUCCESSFUL' | agrTranslate }} </span>
          <br />
          <span
            id="login-forgot-password-link"
            class="small text-primary text-underline"
            (click)="showLostPasswordMsg = true"
            [hidden]="showLostPasswordMsg"
            >{{ 'FORGOT_YOUR_PASSWORD' | agrTranslate }}</span
          >
          <div id="login-forgot-password-msg" class="alert alert-info" [hidden]="!showLostPasswordMsg">
            {{ 'PLEASE_CONTACT_ADMIN_TO_RESET_YOUR_PASSWORD' | agrTranslate }}
          </div>
        </div>
        }
      </div>
      }

      <div class="d-grid">
        <button class="btn btn-primary" id="submit" type="submit">{{ 'LOG_IN' | agrTranslate }}</button>
      </div>
    </form>

    <div id="version-label" [class.fw-bold]="showVersionDetails" (click)="showVersionDetails = !showVersionDetails">
      <span class="small">{{ appInfo.project }}</span>
    </div>
    @if (showVersionDetails) {
    <div id="version-details">
      <div id="client-version-number" class="small">
        {{ 'CLIENT' | agrTranslate }}: {{ appInfo.client.version }}
        @if (appInfo.client.buildInfo) {
        <span> - {{ appInfo.client.buildInfo }}</span>
        }
      </div>
      <div id="api-version-number" class="small">
        API: {{ appInfo.api.version }}
        @if (!!appInfo.api.buildSuffix) {
        <span> - {{ appInfo.api.buildSuffix }}</span>
        }
      </div>
      <div id="database-version-number" class="small">{{ 'DATABASE' | agrTranslate }}: {{ appInfo.database.version }}</div>
    </div>
    }

    <span id="copyright-info" class="small">&copy; AGR Dynamics 2012 - {{ date.getFullYear() }}</span>
  </div>
</div>
